define('home/views/ReplyActivityView',[
    'backbone-marionette',

    'home/mixins/withSubviews',
    'home/views/PostView',
    'home/views/TruncatedPostView',
    'home/templates/replyActivity',
], function (
    Marionette,

    withSubviews,
    PostView,
    TruncatedPostView,
    replyActivityTemplate
) {
    'use strict';

    var parent = Marionette.ItemView;


    /**
     * A view that shows a reply activity. Shown as the parent post followed by
     * the reply post.
     */
    var ReplyActivityView = parent.extend({
        className: 'card-reply',
        template: replyActivityTemplate,

        regions: {
            inReplyToRegion: '[data-role=parent-post]',
            replyRegion: '[data-role=child-post]',
        },

        initialize: function (options) {
            this.shouldCollapse = options && options.shouldCollapse;
        },

        onRender: function () {
            this.activateRegion(this.inReplyToRegion, this.createParentPostView);
            this.activateRegion(this.replyRegion, this.createChildPostView);
        },

        createParentPostView: function () {
            return new TruncatedPostView({
                model: this.model.target,
            });
        },

        createChildPostView: function () {
            return new PostView({
                model: this.model.object,
                shouldCollapse: this.shouldCollapse,
            });
        },
    });


    withSubviews.call(ReplyActivityView.prototype);

    return ReplyActivityView;
});

